export const userProfile = {
  ADMIN: "admin",
  DEALER: "dealer",
  DELIVERYMAN: "deliveryman",
  CUSTOMER: "customer",
} as const;
